import { render, staticRenderFns } from "./importModel.vue?vue&type=template&id=570a3666&scoped=true&"
import script from "./importModel.vue?vue&type=script&lang=js&"
export * from "./importModel.vue?vue&type=script&lang=js&"
import style0 from "./importModel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./importModel.vue?vue&type=style&index=1&id=570a3666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a3666",
  null
  
)

export default component.exports